import {Schema} from 'prosemirror-model';
import {
  defaultMarkdownParser,
  defaultMarkdownSerializer,
  MarkdownParser,
  MarkdownSerializer,
  ParseSpec,
} from 'prosemirror-markdown';
import {mathSerializer} from '@benrbray/prosemirror-math';
import MarkdownIt from 'markdown-it';
import MarkdownItKatex from '@vscode/markdown-it-katex';
import katex from 'katex';

/**
 * Parsing
 */
const allParseSpecs: Record<string, ParseSpec> = {
  ...defaultMarkdownParser.tokens,
  math_inline: {
    block: 'math_inline',
    noCloseToken: true,
  },
  math_block: {
    block: 'math_display',
    noCloseToken: true,
  },
};

export function createMarkdownParser(schema: Schema) {
  const tokenizer = MarkdownIt('commonmark', {
    html: false,
  });

  // @ts-ignore
  tokenizer.use(MarkdownItKatex, {
    katex,
    throwOnError: false,
  });

  tokenizer.disable('image');

  const tokens: Record<string, ParseSpec> = {};

  Object.keys(schema.nodes).forEach((key) => {
    if (allParseSpecs[key]) {
      tokens[key] = allParseSpecs[key];
    }

    if (key === 'math_display') {
      tokens['math_block'] = allParseSpecs['math_block'];
    }

    if (key === 'code_block') {
      tokens['fence'] = allParseSpecs['fence'];
    }

    if (key === 'horizontal_rule') {
      tokens['hr'] = allParseSpecs['hr'];
    }
  });

  Object.keys(schema.marks).forEach((key) => {
    if (allParseSpecs[key]) {
      tokens[key] = allParseSpecs[key];
    }

    if (key === 'code') {
      tokens['code_inline'] = allParseSpecs['code_inline'];
    }
  });

  return new MarkdownParser(schema, tokenizer, tokens);
}

/**
 * Serializeation
 */
const allNodeSerializers: MarkdownSerializer['nodes'] = {
  ...defaultMarkdownSerializer.nodes,
  math_inline(state, node) {
    state.write(mathSerializer.serializeNode(node) || '');
  },
  math_display(state, node) {
    state.write(mathSerializer.serializeNode(node) || '');
  },
};

const allMarkSerializers: MarkdownSerializer['marks'] = {
  ...defaultMarkdownSerializer.marks,
};
export function createMarkdownSerializer(schema: Schema) {
  const nodes: MarkdownSerializer['nodes'] = {};
  const marks: MarkdownSerializer['marks'] = {};

  Object.keys(schema.nodes).forEach((key) => {
    if (allNodeSerializers[key]) {
      nodes[key] = allNodeSerializers[key];
    }
  });

  Object.keys(schema.marks).forEach((key) => {
    if (allMarkSerializers[key]) {
      marks[key] = allMarkSerializers[key];
    }
  });

  return new MarkdownSerializer(nodes, marks);
}
